var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.96009L21.7724 17.242C22.1265 17.8225 22.0459 18.5685 21.576 19.0599L18.7294 22.0367C18.4464 22.3326 18.0547 22.5 17.6453 22.5H13.7048C13.3175 22.5 12.9452 22.3502 12.6658 22.0819L9.50497 19.0463C8.99738 18.5588 8.89694 17.784 9.26344 17.1833L15.5 6.96009Z",
    stroke: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5L15.5 16.5",
    stroke: "#242424"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 17.5,
    r: 1.25,
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H18",
    stroke: "#242424",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTool);
export default __webpack_public_path__ + "static/media/penTool.8f4776a0dd542036f669f6fb44eb5869.svg";
export { ForwardRef as ReactComponent };